import { Navigate, RouteObject } from 'react-router';
import TemplatesList from '@src/components/Home/Config-Beta/Modes/TemplatesList';
import StacksList from '@src/components/Home/Config-Beta/Stacks/StackList';
import AppLayout from '@src/pages/_layout/AppLayout';
import TopBar from './TopBar';
import CalendarView from '@src/components/Home/Config-Beta/Calendar/CalendarView';
import ConfigBetaGuard from './ConfigBetaGuard';
import HMIDefault from '@src/components/Home/Config-Beta/Stacks/HMIDefault';
import ConfigProvider from './ConfigWrapperContext';

export default [
  {
    element: (
      <ConfigBetaGuard>
        <ConfigProvider>
          <AppLayout isNested topBar={<TopBar />} />
        </ConfigProvider>
      </ConfigBetaGuard>
    ),
    children: [
      {
        path: 'config-beta',
        children: [
          { index: true, element: <Navigate to='mode-templates' replace /> },
          { path: 'stacks', element: <StacksList /> },
          { path: 'default-stack', element: <HMIDefault /> },
          { path: 'mode-templates', element: <TemplatesList /> },
          { path: 'calendar', element: <CalendarView /> },
        ],
      },
    ],
  },
] as RouteObject[];
